import { useEffect, useMemo, useState } from 'react';

import useAxios from 'axios-hooks';

export const useCode = () => {
  const [params, setParams] = useState();

  const [
    { data, loading, error },
    executeCodes,
  ] = useAxios({ url: 'codes', params }, { manual: true });

  useEffect(() => {
    if (params) {
      executeCodes();
    }
  }, [params]);

  const getStatuses = () => {
    setParams({
      columnName: 'status',
      tableName: 'scholarships',
    });
  };

  const getStageStatuses = () => {
    setParams({
      columnName: 'status',
      tableName: 'scholarships_stage',
    });
  };

  return useMemo(() => ({
    statuses: data?.codes,
    loadingCodes: loading,
    errorCodes: error,
    getStatuses,
    getStageStatuses,
  }), [
    data,
    loading,
    error,
  ]);
};
